/// <reference path="../jquery/jquery.d.ts" />
/// <reference path="./d/app.d.ts" />

module Sxc.WindowManager
{
	export class Frame
	{
		protected $root  : JQuery;
		protected $frame : JQuery;

		protected onHideCallback    : Function;
		protected onShowCallback    : Function;
		protected onDestroyCallback : Function;

		protected destroyed : boolean;

		constructor(private id: string, escapeable = true)
		{
			this.id = id;
			let template = "<div class=\"frame-wrapper\">\n\t<div class=\"frame-background\"></div>\n\t<div class=\"frame-content\"></div>\n</div>";

			this.$root = $(template);
			this.$root.attr("id", "frame_" + id);
			this.$root.appendTo($("body"));
			this.$frame = this.$root.find(".frame-content");

			$(window).on("keyup", (e) => {
				if (!this.$root.is(":visible")) return;
				let node = e.target.nodeName.toLowerCase();
				if ( node == "select" || node == "input" || node == "option") return;
				if (e.keyCode == 27 && escapeable) this.hide();
			})
		}

		show()
		{
			this.$root.removeClass("hidden");
			if (this.$root.is(":visible")) return;
			//$("html").addClass("disable-scroll");
			if (this.destroyed) return;
			this.$root.show();
			if (this.onShowCallback) this.onShowCallback();
		}

		fauxHide()
		{
			//$("html").removeClass("disable-scroll")
			if (this.destroyed) return;
			if (this.onHideCallback) {
				let r = this.onHideCallback();
				if (r === false) return;
			}
			this.$root.addClass("hidden");
		}

		hide()
		{
			//$("html").removeClass("disable-scroll")
			if (this.destroyed) return;
			if (this.onHideCallback) {
				let r = this.onHideCallback();
				if (r === false) return;
			}
			this.$root.hide();
		}

		destroy()
		{
			if (this.destroyed) return;
			this.$root.hide();
			if (this.onHideCallback) this.onHideCallback();
			this.$root.remove();
			this.destroyed = true;
			if (this.onDestroyCallback) this.onDestroyCallback();
		}

		onHide(callback: Function)
		{
			this.onHideCallback = callback;
		}

		onShow(callback: Function)
		{
			this.onShowCallback = callback;
		}

		onDestroy(callback: Function)
		{
			this.onDestroyCallback = callback;
		}

		setContent($content: JQuery)
		{
			this.$frame.empty().append($content);
		}

		getRoot()
		{
			return this.$root;
		}
	}

	export class Window extends Frame
	{
		protected $title: JQuery;
		protected $content: JQuery;

		constructor(id: string, escapeable = true)
		{
			super(id, escapeable);
			let template = "<div class=\"window-title clearfix\">\n\t<h2></h2>\n\t<a class=\"close\" href=\"#\">\n\t\t<i class=\"fa fa-times-circle\"></i>\n\t</a>\n</div>\n\n<div class=\"window-content\">\n\t\n</div>";
			this.$frame.empty().append(template);
			this.$root.addClass("type-window");
			this.$title = this.$frame.find(".window-title h2");
			this.$content = this.$frame.find(".window-content");

			this.$frame.find(".window-title a.close").on("click", () => {
				this.hide();
			});
		}

		setCloseable(closeable : boolean) {
			this.$frame.find(".window-title a.close")[closeable ? "show" : "hide"]();
		}

		setTitle(title: string)
		{
			this.$title.text(title);
		}

		setContent($content: JQuery)
		{
			this.$content.empty().append($content);
		}
	}
}

